window.readAsDataURL = function(file) {
   return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = reject;
      fr.onload = function() {
         resolve(fr.result);
      }
      //fr.readAsDataURL(file);
      fr.readAsBinaryString(file);
   });
}

window.renameObjectKey = function(obj, oldKey, newKey) {

   if (obj.hasOwnProperty(oldKey)) {
      obj[newKey] = obj[oldKey];
      delete obj[oldKey];
   }

}

window.decodeHTMLEntities = function(text) {
   var textArea = document.createElement('textarea');
   textArea.innerHTML = text;
   return textArea.value;
 }

 window.encodeHTMLEntities = function(text) {
   let textArea = document.createElement('textarea');
   textArea.innerText = text;
   let encodedOutput=textArea.innerHTML;
   let arr=encodedOutput.split('<br>');
   encodedOutput=arr.join('\n');
   return encodedOutput;
 }